import writer from '../icons/Writer.png';
import critic from '../icons/Critic.png';
import producer from '../icons/Producer.png';
import platform from '../icons/Platform.png';
import genreImage from '../genreImage.png';
const prefs = {   
    "status":"success", 
    "msg":"", 
    "data": 
    {
        "intents": [
            {
                "name":"Writer",
                "icon": writer,
                "value": "writer",
                "color": "119, 191, 68",
                "desc": "I want to write industry standard stories",
                "features": [
                    "Discover hundreds of trending stories",
                    "Write your story with powerful tools",
                    "Deep analytics on each story",
                    "Get comments and feedback from community",
                ],
            },
            {
                "name":"Critic",
                "icon": critic,
                "value": "critic",
                "color": "11, 163, 208",
                "desc": "I want to discover and review stories",
                "features": [
                    "Discover content written by Writers",
                    "Grow your credibility as a  Critic in a Genre",
                    "Deep analytics on each story",
                    "Provide Feedback and comments on their Story",
                ],
            },
            {
                "name":"Producer",
                "icon": producer,
                "value": "producer",
                "color": "152, 77, 163",
                "desc": "I am looking for good stories to produce",
                "features": [],
            },
            {
                "name":"Platform",
                "icon": platform,
                "value": "platform",
                "color": "226, 212, 32",
                "desc": "We're looking for a brilliant story to invest",
                "features": [],
            }
        ],

        "genres": [
            {
                "name":"Crime",
                "icon": genreImage,
                "value": "crime"
            },
            {
                "name":"Horror",
                "icon": genreImage,
                "value": "horror"
            }
        ]
    }
}

export default prefs;